export var ApprovalRuleType;
(function (ApprovalRuleType) {
    /** All approve */
    ApprovalRuleType["AllApprove"] = "all_approve";
    /** Any one approval */
    ApprovalRuleType["AnyOneApprove"] = "any_one_approve";
    /** Majority approves */
    ApprovalRuleType["MajorityApprove"] = "majority_approve";
})(ApprovalRuleType || (ApprovalRuleType = {}));
//# sourceMappingURL=approval-rule-type.js.map